import * as HLF from "html-living-framework";

export class PaintableHitArea implements PIXI.HitArea {
    private _target: PIXI.Sprite;
    private _map: number[][];
    private _index: number;
    private _mapMag: number;
    private _norm: PIXI.Point;
    private _pixel: PIXI.Point;

    constructor(pTarget: PIXI.Sprite, pMap: number[][], pIndex: number, pMapMagnification: number = 1) {
        this._target = pTarget;
        this._map = pMap;
        this._index = pIndex;
        this._mapMag = pMapMagnification;

        this._norm = new PIXI.Point();
        this._pixel = new PIXI.Point();
    }

    public get width(): number {
        return this._map.length * this._mapMag;
    }

    public get scaledWidth(): number {
        return this.width * this._target.scale.x * this._mapMag;
    }

    public get height(): number {
        return this._map[0].length * this._mapMag;
    }

    public get scaledHeight(): number {
        return this.height * this._target.scale.y * this._mapMag;
    }

    public contains(pX: number, pY: number): boolean {
        this._norm.x = (pX + this.width * this._target.anchor.x) / (this.width);
        this._norm.y = (pY + this.height * this._target.anchor.y) / (this.height);

        // If we are within the bounds of the texture
        if (this._norm.x >= 0 && this._norm.x <= 1 && this._norm.y >= 0 && this._norm.y <= 1) {
            this._pixel.x = Math.floor(HLF.MathUtils.clamp(
                this._norm.x * this._map.length,
                0,
                this._map.length - 1,
            ));
            this._pixel.y = Math.floor(HLF.MathUtils.clamp(
                this._norm.y * this._map[0].length,
                0,
                this._map[0].length - 1,
            ));
            return this._map[this._pixel.x][this._pixel.y] === this._index;
        }
        else {
            return false;
        }
    }
}
